export const defaultState = {
  loginState: 'LOGGED_OUT',
  service: null,
  memberId: null,
  module: null,
  consultationNumber: null,
  relativeId: null,
  loginNumber: null,
  loginCountryCode: null,
  appError: {
    hasError: false,
    errorTitle: 'Something went wrong',
    errorDesc: 'Check your internet connection and try again',
  },
  config: {
    showQChat: false,
    showOPD: false,
    showSubscription: false,
    showMeds: false,
    showLabs: false,
    showFeed: false,
    showFitCoins: false,
    showOffline: false,
    showSymCheck: false,
    insured: false,
    transFitCoins: false,
    insurePortal: 'https://getvisitapp.com/buy-subscription.html',
    cancellationFee: 100,
    showManageDependent: false,
    showHraHeader: true,
    showUpdatedHra: false,
  },
  logRocketInitiated: false,
};

export default function app(state = defaultState, action) {
  switch (action.type) {
    case 'OTP_SENT':
      return Object.assign({}, state, {
        loginState: action.type,
        loginNumber: action.payload.phoneNumber,
        loginCountryCode: action.payload.countryCode,
      });
    case 'UPDATE_LOGIN_STATE':
      return Object.assign({}, state, {
        loginState: action.payload.state,
      });
    case 'SHOW_ERROR': {
      return Object.assign({}, state, {
        appError: {
          hasError: true,
          errorTitle: action.payload.errorTitle,
          errorDesc: action.payload.errorDesc,
        },
      });
    }
    case 'HIDE_ERROR': {
      return Object.assign({}, state, {
        appError: {
          hasError: false,
          errorTitle: 'Something went wrong',
          errorDesc: 'Check your internet connection and try again',
        },
      });
    }
    case 'SET_APP_CONFIG': {
      const updatedConfig = Object.assign(
        {},
        state.config,
        action.payload.config
      );
      console.log(updatedConfig, action.payload.config);
      return Object.assign({}, state, {
        config: {
          ...updatedConfig,
          showUpdatedHra: action.payload.config.showUpdatedHra || false,
        },
      });
    }
    case 'SET_CLIENT_INFO': {
      return Object.assign({}, state, {
        service: action.payload.service,
        module: action.payload.module,
        memberId: action.payload.memberId,
        consultationNumber: action.payload.consultationNumber,
        relativeId: action.payload.relativeId,
      });
    }
    case 'UNSET_CLIENT_INFO': {
      return Object.assign({}, state, {
        service: null,
        memberId: null,
        module: null,
        consultationNumber: null,
        relativeId: null,
      });
    }
    case 'SET_LOG_ROCKET': {
      return Object.assign({}, state, {
        logRocketInitiated: action.payload,
      });
    }
    default:
      return state;
  }
}
